import { useCallback } from 'react'

import type { ButtonClickedData } from '@b-stock/fe-core/bstock-react'
import {
  AnalyticsEntityType,
  AnalyticsSource,
} from '@b-stock/fe-core/bstock-react'

import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

type TrackFilterUsageData = Omit<
  ButtonClickedData,
  'buttonName' | 'screenName' | 'source' | 'entityType'
> & {
  buttonName?: never
  screenName?: never
  source?: never
  entityType?: never
}

// This type parameter allows us to (optionally) add extra type checking to filter usage tracking
// to help minimize the risk of someone forgetting to include one of the expected data points when
// tracking and/or sending incorrect data types for certain values
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const useTrackFilterUsage = <T extends TrackFilterUsageData>(
  buttonName: string
) => {
  const { trackButtonClicked } = useAnalytics()

  return useCallback(
    (data: T) => {
      trackButtonClicked({
        ...data,
        buttonName,
        source: AnalyticsSource.HOME_PORTAL, // source
        entityType: AnalyticsEntityType.BUYER, // entity_type
      })
    },
    [buttonName, trackButtonClicked]
  )
}
